import { render, staticRenderFns } from "./Statement.vue?vue&type=template&id=2a437840&scoped=true&"
var script = {}
import style0 from "./Statement.vue?vue&type=style&index=0&id=2a437840&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a437840",
  null
  
)

export default component.exports